import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';

import axios from 'axios';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';

import {
    VStack
    , SelectPicker
    , ButtonToolbar
    , Whisper
    , Tooltip
    , IconButton
    , Text
    , Loader
} from 'rsuite';

import TH_Sarabun_PSK from '../../fonts/TH_Sarabun_PSK/THSarabun.ttf'

export default class ReportPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authHeader: { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } },
            reportData01: [],
        };
    }

    async componentDidMount() {
        await this.onRenderContent({ mode: 'read', report: 0 })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    onRenderContent = async ({ mode, report }) => {
        if (mode === 'read') {
            try {
                await this.promisedSetState({ loading: true })

                // Report 01 
                const { data: reportData01 } = await axios.get(`${process.env.REACT_APP_API}/report01`, this.state.authHeader);
                const { data: [reportData01Year] } = await axios.get(`${process.env.REACT_APP_API}/report01year`, this.state.authHeader);
                const years = Array.from({ length: reportData01Year.default_year - 2543 + 1 }, (_, i) => 2543 + i);

                await this.promisedSetState({
                    content:
                        <>
                            <Row className='mt-3'>
                                <Col>
                                    <Breadcrumb size='lg' >
                                        <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                        <Breadcrumb.Item active>รายงาน</Breadcrumb.Item>
                                    </Breadcrumb>
                                </Col>
                            </Row>

                            <Row>
                                {/* <Col lg={2} className='mb-2'>
                                    <VStack>
                                        <label>ปีการศึกษา</label>
                                        <SelectPicker
                                            size='lg'
                                            cleanable={false}
                                            data={[{ value: '2567', label: '2567' }]}
                                            searchable={false}
                                            style={{ width: '100%' }}
                                            placeholder='กรุณาเลือก'
                                        />
                                    </VStack>
                                </Col> */}
                                <Col lg={6} className='mb-2'>
                                    <VStack>
                                        <label>รายงาน</label>
                                        <SelectPicker
                                            size='lg'
                                            data={[
                                                { value: 1, label: 'ฐานข้อมูลนักเรียนทุนรายปีการศึกษา' },
                                                // { value: 2, label: 'รายละเอียดนักเรียนทุน ประจำปีการศึกษา' },
                                            ]}
                                            style={{ width: '100%' }}
                                            placeholder='กรุณาเลือก'
                                            onSelect={v => this.onRenderContent({ mode, report: v })}
                                            onClean={() => this.onRenderContent({ mode, report: 0 })}
                                        />
                                    </VStack>
                                </Col>
                                <Col className='mb-2 d-flex justify-content-end'>
                                    <ButtonToolbar>
                                        <Whisper
                                            followCursor
                                            speaker={<Tooltip>Print</Tooltip>}
                                        >
                                            <IconButton
                                                icon={<i className="bi bi-printer"></i>}
                                                style={{ backgroundColor: '#adadad', color: 'white' }}
                                                onClick={this.handlePrint}
                                            />
                                        </Whisper>
                                        <Whisper
                                            followCursor
                                            speaker={<Tooltip>Excel</Tooltip>}
                                        >
                                            <IconButton
                                                color="green"
                                                appearance="primary"
                                                icon={<i className="bi bi-file-earmark-excel"></i>}
                                                onClick={this.handleExportToExcel}
                                            />
                                        </Whisper>
                                    </ButtonToolbar>
                                </Col>
                            </Row>

                            <Row className='mt-2'>
                                <Col>
                                    <Card id="printable" border="light" className='shadow-sm'>
                                        <Card.Body>
                                            <Card.Text>
                                                {report === 0 && <div style={{ textAlign: 'center', padding: '2em' }}><Text muted style={{ fontSize: '18pt' }}>กรุณาเลือกรายงาน</Text></div>}
                                                {report === 1 && (
                                                    <>
                                                        <div style={{ textAlign: 'center' }}>
                                                            <span><b>รายงานฐานข้อมูลนักเรียนทุน ปีการศึกษา 2543 - {years?.[years.length - 1]}</b></span>
                                                        </div>
                                                        <br />
                                                        <div style={{ overflowX: 'auto' }}>
                                                            <table style={{ border: '1px solid black', borderCollapse: 'collapse', fontSize: '14pt', width: '100%' }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th rowSpan="2" style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ลำดับ</th>
                                                                        <th rowSpan="2" style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>สถานศึกษา</th>
                                                                        <th colSpan={years?.length || 0} style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ปีการศึกษา</th>
                                                                        <th rowSpan="2" style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>รวมทั้งหมด</th>
                                                                    </tr>
                                                                    <tr>
                                                                        {years?.map((year) => (
                                                                            <th key={year} style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>
                                                                                {year}
                                                                            </th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {reportData01?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            {/* Serial number for each row */}
                                                                            <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>
                                                                                {index + 1}
                                                                            </td>

                                                                            {/* School Name */}
                                                                            <td style={{ border: '1px solid black', padding: '4px' }}>
                                                                                {item.name}
                                                                            </td>

                                                                            {/* Loop through years and display corresponding values */}
                                                                            {years?.map((year, i) => {
                                                                                const yearKey = `${year}`; // Build key like 2543

                                                                                return (
                                                                                    <td key={i} style={{ border: '1px solid black', padding: '4px', textAlign: 'right' }}>
                                                                                        {item[yearKey] || 0} {/* Fallback to 0 if data is missing */}
                                                                                    </td>
                                                                                );
                                                                            })}

                                                                            {/* Sum all year values for this school */}
                                                                            <td style={{ border: '1px solid black', padding: '4px', textAlign: 'right' }}>
                                                                                {years?.reduce(
                                                                                    (sum, year) => sum + (item[`${year}`] || 0), 0
                                                                                )} {/* Sum all year values */}
                                                                            </td>
                                                                        </tr>
                                                                    ))}

                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <td style={{ border: '1px solid black', padding: '4px' }}></td>  {/* Empty cell */}
                                                                        <td style={{ border: '1px solid black', padding: '4px' }}>รวมทั้งหมด</td>  {/* "Total" label */}

                                                                        {/* Loop through each year to calculate and display year-wise totals */}
                                                                        {years?.map((year) => {
                                                                            const total = reportData01?.reduce((sum, item) => sum + (item[`${year}`] || 0), 0);
                                                                            return (
                                                                                <td key={year} style={{ border: '1px solid black', padding: '4px', textAlign: 'right' }}>
                                                                                    {total} {/* Display year-wise total */}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                        {/* Calculate and display the grand total of all years */}
                                                                        <td style={{ border: '1px solid black', padding: '4px', textAlign: 'right' }}>
                                                                            {reportData01?.reduce((sum, item) => {
                                                                                return sum + years.reduce((yearSum, year) => yearSum + (item[`${year}`] || 0), 0);
                                                                            }, 0)} {/* Grand total */}
                                                                        </td>

                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    </>
                                                )}

                                                {/* {report === 2 &&
                                                    <div>
                                                        <div style={{ textAlign: 'center' }}>
                                                            <span><b>รายงานรายละเอียดนักเรียนทุน ประจำปีการศึกษา 2567</b></span>
                                                        </div>
                                                        <br />
                                                        <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%' }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ลำดับ</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ชื่อ สกุล</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>หมู่บ้าน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>โครงการพัฒนาดอยตุงฯ</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>บุตรพนักงาน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ปางมะหัน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>น่าน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ร้อยใจรักษ์</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>โรงเรียนห้วยไร่</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>อื่นๆ</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>สถานศึกษา</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>สาขาที่เรียน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ปีที่ได้รับทุน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ปีที่เรียนจบ</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>สถานะการเรียน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>เบอร์โทรติดต่อ</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>สถานที่ทำงานปัจจุบัน</th>
                                                                    <th style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>หมายเหตุ</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>1</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}>นางสาวหนึ่งฤทัย ทักษิณมณี</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}>ดอยหลวง</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>FALSE</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>FALSE</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>FALSE</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>FALSE</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>FALSE</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>FALSE</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>TRUE</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}>จุฬาลงกรณ์มหาวิทยาลัย</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}>ทันตแพทย์</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>ปี 2543</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}></td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}>จบการศึกษา</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}></td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}>รพ.แม่จัน และ สถานีอนามัยเฉลิมพระเกียรติดอยตุงฯ</td>
                                                                    <td style={{ border: '1px solid black', padding: '4px' }}>นักเรียนทุนไร่แม่ฟ้าหลวง/ไม่ทราบปีที่จบ</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>} */}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <br/>
                                </Col>
                            </Row>
                        </>
                })

                await this.promisedSetState({ loading: false })
            } catch {
                // Redirect to Log In
                window.location.href = '/admin/login';
            }
        }
    }

    generateRandomString = (amount) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < amount; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    handlePrint = () => {
        // Open a new window with full screen size (height and width of the current browser window)
        const printWindow = window.open('', '', `height=${window.innerHeight},width=${window.innerWidth}`);

        const content = document.getElementById('printable').innerHTML; // Get content to print by ID

        // Define the print styles and include the font-face rule
        const printStyles = `
            @font-face {
                font-family: 'TH_Sarabun';
                src: url(${TH_Sarabun_PSK});
            }
            body {
                font-family: 'TH_Sarabun', sans-serif;
                font-size: 14pt;
                line-height: 1.2;
            }
            /* Additional styles for printing */
            @page {
                size: landscape;
                margin: 1cm;
            }
        `;

        const randomString = this.generateRandomString(8); // Generate a random 8-character string

        // Write the content into the new window
        printWindow.document.write(`<html><head><title>${randomString}</title>`);
        printWindow.document.write(`<style>${printStyles}</style>`);  // Add styles to the print window
        printWindow.document.write('</head><body>');
        printWindow.document.write(content); // Add the content to print
        printWindow.document.write('</body></html>');

        // Close the document and trigger the print dialog after a delay
        printWindow.document.close();

        // Add delay for the content to load properly
        setTimeout(() => {
            printWindow.print();
        }, 500); // Adjust time if necessary
    };

    handleExportToExcel = () => {
        const randomString = this.generateRandomString(8); // Generate a random 8-character string
        const table = document.getElementById('printable'); // Table ID you want to export

        // Check if the table exists
        if (!table) {
            alert("Table not found!");
            return;
        }

        // Convert the table to a worksheet
        const ws = XLSX.utils.table_to_sheet(table);
        const wb = XLSX.utils.book_new(); // Create a new workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1'); // Append worksheet to the workbook

        // Trigger the download with a random filename
        XLSX.writeFile(wb, randomString + '.xlsx');
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
